"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VrfSubInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const provider_user_1 = require("@dzambalaorg/provider-user");
const VrfSubInput = () => {
    const form = (0, react_hook_form_1.useFormContext)();
    const { profile } = (0, provider_user_1.useUser)();
    const handleChange = (_event, option) => {
        form.setValue("subId", option?.id ?? 0, { shouldDirty: true });
        form.setValue("vrfSubId", option?.vrfSubId ?? 0, { shouldDirty: true });
    };
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "subId", getTitle: (option) => `SubId #${option.vrfSubId}`, controller: "chain-link/subscriptions", fetchData: {
            chainId: profile.chainId,
            merchantId: profile.merchantId,
        }, onChange: handleChange, autoSelect: true }));
};
exports.VrfSubInput = VrfSubInput;
//# sourceMappingURL=index.js.map